module.exports = __webpack_public_path__ + "img/table.b52d8199.png";